import { GrantsType, hasScopedPermission } from '../../Shared/utils/auth';

export const createPartnerPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'partners.create') ||
  hasScopedPermission(grants, 'system', 'partners.create');
